// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"4ae07b87","357":"375bab41"}[chunkId] + ".chunk.js";
};